/**
 * 수강 신청 유형
 * @enum {string}
 */
export const ENROLMENT_TYPE = {
    /** 추첨 */
    RANDOM: 'RANDOM',
    /** 선착순 */
    FCFS: 'FCFS',
    /** 자동 추첨 */
    DRAW_PRIOR: 'DRAW_PRIOR',
};

/**
 * 설문 옵션 유형
 * @enum {string}
 */
export const SURVEY_OPTION_TYPE = {
    /** 마스킹 여부 */
    MASKING: 'MASKING',
    /** 거절 가능 여부 */
    ALLOW_DENY: 'ALLOW_DENY',
    /** 수정 가능 여부 */
    ALLOW_EDIT: 'ALLOW_EDIT',
    /** 추첨 유형 */
    DRAW_TYPE: 'DRAW_TYPE',
    /** 중복 신청 가능 여부 */
    ALLOW_APPLY_DUPLICATE: 'ALLOW_APPLY_DUPLICATE',
};

/**
 * 추첨 유형
 * @enum {string}
 */
export const SURVEY_OPTION_DRAW_TYPE = {
    /** 우선순위 추첨 */
    DRAW_PRIOR: 'DRAW_PRIOR',
}

/**
 * 질문 유형
 * @readonly
 * @enum {string}
 */
export const QUESTION_TYPE = {
    /** 수강신청 질문 */
    ENROLMENT: 'ENROLMENT',
    /** 수강신청 동의문 */
    ENROLMENT_AGREEMENT: 'ENROLMENT_AGREEMENT',
    /** 수강신청 질문 (미사용, 2025.08.08 1차 배포시 나갔던 내용으로 오류 발생을 막기 위해 남겨둠) */
    ENROLMENT_QUESTION: 'ENROLMENT_QUESTION',
    /** 수강신청 강좌 질문 */
    ENROLMENT_PROGRAM: 'ENROLMENT_PROGRAM',
    /** 일반 설문 */
    SURVEY: 'SURVEY',
    /** 테이블형 말단 질문 */
    SURVEY_TABLE: 'SURVEY_TABLE',
    /** 선착순 설문 */
    SURVEY_FCFS: 'SURVEY_FCFS',
    /** 서명 */
    SURVEY_SIGN: 'SURVEY_SIGN'
};

/**
 * 질문 옵션
 * @enum {string}
 */
export const QUESTION_OPTION = {
    /** 신청 가능 강좌 수 */
    MAX_CHOICE: 'MAX_CHOICE',
    /** 수강 신청 유형 */
    ENROLMENT_TYPE: 'ENROLMENT_TYPE',
    /** 질문 노출될 태그 */
    FILTER_TAG: 'FILTER_TAG',
    /** 정원 */
    LIMIT: 'LIMIT',
    /** 예비 정원 */
    RESERVED_LIMIT: 'RESERVED_LIMIT',
    /** 설문 선착순 유형(상위 질문) */
    IS_PARENT_FCFS: 'IS_PARENT_FCFS',
    /** 필수 여부 */
    MANDATORY: 'MANDATORY',
    /** 비용 */
    COST: 'COST',
};

/**
 * 답변 유형
 * @enum {string}
 */
export const ANSWER_TYPE = {
    /** 객관식 단일 */
    ONE_CHOICE: 'ONE_CHOICE',
    /** 객관식 복수 */
    MULTI_CHOICE: 'MULTI_CHOICE',
    /** 주관식 */
    TEXT: 'TEXT',
    /** 테이블 형 */
    TABLE: 'TABLE',
    /** 테이블 형의 하위 */
    SUB_TABLE: 'SUB_TABLE',
    /** 서명 */
    SIGN: 'SIGN',
    /** 학부모 상담 주간 */
    PARENT_COUNSEL_WEEK: 'PARENT_COUNSEL_WEEK',
    /** 학부모 상담 주간 - 상담 시간 */
    PARENT_COUNSEL_WEEK_TIME: 'PARENT_COUNSEL_WEEK_TIME',
};

/**
 * 주관식 길이
 * @enum {string}
 */
export const TEXT_LENGTH = {
    SHORT: 'SHORT',
    MIDDLE: 'MIDDLE',
    LONG: 'LONG'
};

/**
 * 주관식 길이 값
 * @enum
 */
export const TEXT_LENGTH_VALUE = {
    SHORT: 150,
    MIDDLE: 150,
    LONG: 500
};

/**
 * 설문 공유 타입
 * @enum {string}
 */
export const SHARE_TYPE = {
    /** 학교 내 공유 */
    SCHOOL: 'SCHOOL',
    /** 전체 공유 */
    ALL: 'ALL'
};

/**
 * 방과후학교 신청기간 상태
 * @enum {string}
 */
export const PERIOD_STATE_TYPE = {
    BEFORE_PERIOD: 'BEFORE_PERIOD',
    ONGOING: 'ONGOING',
    ENDED: 'ENDED',
}

/**
 * 학부모 상담 주간 시간 없음 옵션
 * @enum
 */
export const PARENT_COUNSEL_WEEK_NO_TIME_OPTION = {
    /** 사용 (주관식 질문 추가) */
    USE_TEXT: 'USE_TEXT',
    /** 사용 (질문 없음) */
    USE_NO_TEXT: 'USE_NO_TEXT',
    /** 사용안함 */
    NOT_USE: 'NOT_USE',
}
